import { module } from 'angular';
import component from './zip-arbo.component';
import './zip-arbo.scss';

export default module('app')
	.component('zipArbo', component)
	.name;
